(function () {
    'use strict';

    angular.module('swif.interventions')
    .directive('swifSiteOrEquipment', swifSiteOrEquipment);

    function SiteOrEquipmentCtrl($scope, $timeout, swif, carto, swifPatrimoineReferentielService) {
        'ngInject';
        var $ctrl = this;
        $ctrl.showCarto = swif.settings.app.features.showCarto;
        $ctrl.modules = swif.module.modules;
/*            scope.choices = [
            {id: 0, name: 'site', field:'site1', icon: '<i class="fa fa-map-marker"></i>'},
            {id: 1, name: 'equipment', field:'equipment_id', icon: '<i class="fa fa-wrench"></i>'}
        ];*/
        $ctrl.display = {
            site: true,
            map: false,
            _map: false
        };

        var API = { childOnCollapse: childOnCollapse };

        function childOnCollapse() {
                $scope.ngModel._collapsed = !$scope.ngModel._collapsed;
                if (!$scope.ngModel._collapsed){
                    $ctrl.display._map = true;
                     // We display the map with a delay, otherwise an offset appear
                    $timeout(() => {
                        displayMap();
                    }, 100);
                }
            }

        if (swif.module.modules.opengst_carto) {
            $ctrl.toggleDisplay = toggleDisplay;
            $ctrl.displayMap = displayMap;
        }
        if (!$scope.ngModel.site_details){
            delete $scope.ngModel.site_details;
        }
        $ctrl.filter = {};
        $ctrl.filter.restrictIds = false;
        var user = swif.user.getAuthenticatedUserData();
        var getPartner = swif.user.getPartner(['technical_site_ids']);
        // initialize currentChoice according to ngModel data
        $ctrl.onEquipmentChange = onEquipmentChange;
        $ctrl.onMapInitialized = function (map) {
            $ctrl.map = map;
            setMapStuffFromSiteData();
        };

        $ctrl.isVSNFeature = swif.settings.app.features.isVSN;

        this.$onInit = function () {
            $ctrl.fullView = _.contains(user.access_rights, 'openstc_full_view');
            $ctrl.isVSN = swif.settings.app.features.isVSN;

            this.onInit = $scope.onInit({$API: API});

            // Always show map on limited view - TG3476-VSN : show map by default for everyone
            if ($ctrl.modules.opengst_carto && (!$ctrl.fullView || $scope.ngModel.geo_point || $ctrl.isVSN) && !$scope.ngModel.isTaskRange) {
                $ctrl.display._map = true;
                // We display the map with a delay, otherwise an offset appears
                $timeout(() => {
                    displayMap();
                }, 100);
            }

            // sets default intervention parent site for task site if it's linked to an intervention
            // VSN feature only
            var siteOnTaskFeature = swif.settings.app.features.siteOnTask;
            if (!$scope.ngModel.site1 &&!$scope.ngModel.equipment_id && $scope.ngModel.project_id) {
                var params = {fields: ['site1', 'equipment_id', 'site_details']};
                var projectid = $scope.ngModel.project_id[0]
                var parent_site = swif.data.get('intervention', projectid, params)
                parent_site.then(function (data) {
                    $scope.ngModel.site1 = data.site1;
                    $scope.ngModel.site_details = data.site_details;
                    $scope.ngModel.equipment_id = data.equipment_id;
                });
            }

            $ctrl.display.equipment = $scope.ngModel.equipment_id ? true:false;
            if (!$scope.ngModel.equipment_id && $scope.ngModel._display_equipment_id) {
                $ctrl.display.equipment = true;
            }

            $scope.$watch('ngModel.service_id', function (){
                updateFilter();
            });

            $scope.$watch('ngModel.site1', function(newV) {
                updateFilter();
                if (swif.module.modules.opengst_carto) {
                    setGeolocationFromSite(newV);
                }
            });
        };


        function toggleDisplay (id) {
            $ctrl.display[id] = !$ctrl.display[id];
        }
        function displayMap() {
            if ($ctrl.display._map) {
                swif.resources.add(['leaflet']).then(function () {
                    $ctrl.display.map = true;
                });
            } else {
                $ctrl.display.map = false;
            }
        }
        function updateFilter () {
            $ctrl.filter = {equipments: {fields: ['name', 'complete_name', 'site_id']}, sites:{}};
            getPartner.then(function (partner) {
                if (partner){
                    if (!_.isEmpty(partner.technical_site_ids) && !['task', 'intervention'].includes($scope.ngModel._type)) {
                        swif.data.addFilter(
                            $ctrl.filter.sites,
                            'id', 'child_of', partner.technical_site_ids
                        );
                        $ctrl.filter.restrictIds = partner.technical_site_ids;
                    }
                }
            });
            var isInter = false;
            var isInterRequest = false;
            if ($scope.ngModel) {
                if ($scope.ngModel._type === 'intervention' || $scope.siteSubtitle === 'la tâche') {
                    isInter = true;
                } else if ($scope.ngModel._type === 'intervention_request' || $scope.siteSubtitle === 'la demande') {
                    isInterRequest = true;
                }
                // for equipments, add domain related to owner / user
                if (isInter) {
                    swif.data.addFilter($ctrl.filter.equipments, '|');
                }
                if (!isInterRequest && isInter) {
                    swif.data.addFilter($ctrl.filter.equipments, '|');
                    // for equipments, service_ids is ownership, not maintenance field
                    swif.data.addFilter(
                        $ctrl.filter.equipments,
                        'maintenance_service_ids', 'in', user.service_ids || []
                    );
                    swif.data.addFilter(
                        $ctrl.filter.equipments,
                        'maintenance_service_ids', '=', false
                    );
                }

                // Don't update equipments filters if an equipment is already seleted
                if (!$scope.ngModel.equipment_id && $scope.ngModel.site1) {
                    var _sites = [$scope.ngModel.site1[0]];
                    swifPatrimoineReferentielService.getChildren($scope.ngModel.site1[0]).then(function (sites) {
                        sites.map((site) => {
                            _sites.push(site.id);
                        });
                    });
                    swif.data.addFilter(
                        $ctrl.filter.equipments,
                        'site_id', '=', _sites
                    );
                }
                if (isInter) {
                    // for internal user, add too the equipments
                    // maintained by its services (if those services are set-up to allow that)
                    swif.data.addFilter($ctrl.filter.equipments, '&');
                    swif.data.addFilter(
                        $ctrl.filter.equipments,
                        'maintenance_service_ids.allows_ask_on_maintained_equipment',
                        '=',
                        true
                    );
                    swif.data.addFilter(
                        $ctrl.filter.equipments,
                        'maintenance_service_ids',
                        'in',
                        user.service_ids || []
                    );
                }
                if ($scope.ngModel.service_id && isInter) {
                    swif.data.addFilter(
                        $ctrl.filter.sites,
                        '|'
                    );
                    swif.data.addFilter(
                        $ctrl.filter.sites,
                        'service_ids.id', '=', $scope.ngModel.service_id[0]
                    );
                    swif.data.addFilter(
                        $ctrl.filter.sites,
                        'service_ids', '=', false
                    );
                    swif.data.addFilter(
                        $ctrl.filter.equipments,
                        '|'
                    );
                    swif.data.addFilter(
                        $ctrl.filter.equipments,
                        'maintenance_service_ids.id', '=', $scope.ngModel.service_id[0]
                    );
                    swif.data.addFilter(
                        $ctrl.filter.equipments,
                        'maintenance_service_ids', '=', false
                    );
                }
            }
        }
        //Download location of all sites
        function downloadSiteLocation(siteid) {
            var params = {fields: ['geo_point', 'geometry', 'osm_zoom']};
            if ($ctrl.isVSN){
                var params = {fields: ['geo_point', 'geometry', 'osm_zoom', 'geo_polygon', 'geo_line',  'geo_multi_line', 'geo_multi_polygon']};
            }
            return swif.data.get('site', siteid, params);
        }
        function setGeolocationFromSite(newV) {
            if (newV) {
                downloadSiteLocation(newV[0]).then(function (data) {
                    $ctrl.site_data = data;
                    setMapStuffFromSiteData();
                });
            }
        }

        // TG3803 VSN - get a point from a geometry witch is not point type
        function getPointFromGeometry(site_data) {

            if (site_data.geo_polygon) {
                var geo_polygon = JSON.parse(site_data.geo_polygon)
                geo_polygon.coordinates[0].length = 1;
                geo_polygon.coordinates = geo_polygon.coordinates[0][0].reverse();
                return JSON.stringify(geo_polygon)
            }
            if (site_data.geo_line) {
                var geo_line = JSON.parse(site_data.geo_line)
                geo_line.coordinates.length = 1;
                geo_line.coordinates = geo_line.coordinates[0].reverse();
                return JSON.stringify(geo_line)
            }
            if (site_data.geo_multi_line) {
                var geo_multi_line = JSON.parse(site_data.geo_multi_line)
                geo_multi_line.coordinates[0].length = 1;
                geo_multi_line.coordinates = geo_multi_line.coordinates[0][0].reverse();
                return JSON.stringify(geo_multi_line)
            }
            if (site_data.geo_multi_polygon) {
                var geo_multi_polygon = JSON.parse(site_data.geo_multi_polygon)
                geo_multi_polygon.coordinates[0][0].length = 1;
                geo_multi_polygon.coordinates = geo_multi_polygon.coordinates[0][0].reverse();
                return JSON.stringify(geo_multi_polygon)
            }

            return false

        }

        function onEquipmentChange(equipment) {
            if (!$scope.ngModel.site1 && equipment.site_id) {
                $scope.ngModel.site1 = angular.copy(equipment.site_id);
            }
        }

        function setMapStuffFromSiteData() {
            if (!$ctrl.map || !$ctrl.site_data) {
                return;
            }
            $ctrl.isVSN = swif.settings.app.features.isVSN;
            if ($ctrl.site_data.geo_point) {

                // TG-3522 - show site pin
                if ($ctrl.isVSN && !$scope.ngModel.changeSiteFromMap) {
                    $scope.ngModel.latlng = $ctrl.site_data.geo_point
                } else {
                    var latlng = carto.leaflet.getLatLngFromPoint($ctrl.site_data.geo_point);
                    $ctrl.map.setView(latlng);
                }
                $scope.ngModel.changeSiteFromMap = false
            }
            // TG3803 VSN - get a point from a geometry witch is not point type, case when it's a new intervention
            else if ($ctrl.isVSN && !$scope.ngModel.id && ($ctrl.site_data.geo_polygon || $ctrl.site_data.geo_line
                || $ctrl.site_data.geo_multi_line || $ctrl.site_data.geo_multi_polygon)) {
                $scope.ngModel.latlng = getPointFromGeometry($ctrl.site_data)
            }
            if ($ctrl.isVSN && $ctrl.site_data.osm_zoom) {
                $ctrl.map.setZoom($ctrl.site_data.osm_zoom);
                $scope.ngModel.zoom = $ctrl.site_data.osm_zoom
            }
        }
        $ctrl._onInitMap = function () {
            if (swif.settings.app.features.showCarto) {
                $ctrl.display._map=true;
                // We display the map with a delay, otherwise an offset appears
                $timeout(() => {
                    $ctrl.displayMap();
                }, 100);
            }
        }
    }

    function swifSiteOrEquipment (swif, carto) {
        'ngInject';
        var d = angular.copy(swif.form.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.onInit = '&';
        d.scope.ngModel = '=';
        d.scope.siteDetails = '@';
        d.scope.siteSubtitle = '@';
        d.link = link;
        d.controller = SiteOrEquipmentCtrl;
        d.controllerAs = '$ctrl';
        d.templateUrl = 'partials/openstc/form_site_or_equipment.html';
        return d;

        function link (scope, element) {
            swif.form.watchNgRequired(scope, element);
        }
    }

})();
